import React, { useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import { useNavigate, useParams } from "react-router-dom";
import IOrder from "../../../models/IOrder";
import IPayment from "../../../models/IPayment";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import ActivityIndicator from "../../shared/ActivityIndicator/ActivityIndicator";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import { CreditCardBrandIcon } from "../../shared/CreditCardBrandIcon/CreditCardBrandIcon";
import { NumericFormat } from "react-number-format";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import IImageSizeEnum from "../../../models/IImageSizeEnum";
import styled from "styled-components";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import UIService from "../../../services/UIService";
import { Socket } from "socket.io-client";
import { QtyDetail } from "../../shared/QtyDetail/QtyDetail";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import HelperService from "../../../services/HelperService";
import { KitItemsDisplay } from "../../shared/KitItemsDisplay/KitItemsDisplay";

type Props = {};

export const EcommerceInvoice: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const params = useParams();
    const history = useNavigate();

    // @ts-expect-error
    const { guid } = params;

    const [order, setOrder] = useState<IOrder>();
    const [paymentDetail, setPaymentDetail] = useState<IPayment>();
    const [paymentMethodDetail, setPaymentMethodDetail] = useState<{ brand: string; last4: string }>();

    const onGetOrder = (data: IOnGetOrderDTO) => {
        setOrder(data.order);

        if (data.order.Payments?.length) {
            setPaymentDetail(data.order.Payments[0]);

            const captureDetail = JSON.parse(data.order.Payments[0].capture_detail!);

            if (captureDetail) {
                const last4 = captureDetail.charges.data[0].payment_method_details.card.last4;
                const brand = captureDetail.charges.data[0].payment_method_details.card.brand;

                setPaymentMethodDetail({ last4, brand });
            }
        }
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.OrderOnGetOrder, fn: onGetOrder }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getOrder();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const getOrder = () => {
        if (guid) {
            const payload: IGetOrderDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel.guid,
                orderGuid: guid,
            };

            socket.emit(EndpointsEnum.OrderGetOrder, payload);
        }
    };

    return (
        <div className={"EcommerceInvoice container"}>
            {!order ? (
                <div>
                    <ActivityIndicator active={true} />
                    <OwLabel title={"loading"} />
                </div>
            ) : (
                <div>
                    <div className={"d-flex justify-content-center"}>
                        <OwPrintButton />
                    </div>

                    <div className={"d-flex justify-content-between"}>
                        <div>
                            <div>
                                <OwLabel title={"order_placed"} postText={":"} isBold={true} /> {UserService.parseDate(order.created_at)}
                            </div>
                            <div>
                                <OwLabel title={"order_no"} postText={":"} isBold={true} /> {order.name}
                            </div>
                            <div>
                                <OwLabel title={"order_total"} postText={":"} isBold={true} />{" "}
                                {HelperService.formatCurrency({
                                    value: order.grand_total || 0,
                                    currency: "USD",
                                    precision: supplierModel.pricing_precision || 2,
                                })}
                            </div>
                        </div>
                    </div>

                    <SectionContainerDiv className={"mt-4 justify-content-between"}>
                        <InnerContentDiv className={"text-center"}>
                            <OwTitle title={"item_information"} tag={"h5"} isBold={true} />
                        </InnerContentDiv>

                        <CenterLineDiv />

                        <InnerContentDiv>
                            <div className={"mb-2 d-flex justify-content-between"}>
                                <OwLabel title={"items_ordered"} isBold={true} />
                                <OwLabel title={"price"} isBold={true} />
                            </div>
                            {order.Order_Items.map((orderItem) => {
                                const totalPrice = (orderItem.cost_price_frozen || 0) * orderItem.qty;

                                return (
                                    <div key={orderItem.guid} className={"mb-5 d-flex justify-content-between"}>
                                        <div className={""}>
                                            <div>{orderItem.Catalog_Item?.name}</div>
                                            <div>
                                                <QtyDetail item={orderItem} className={"text-end"} />
                                                <OwLabel title={"at"} className={"ms-2 me-2"} />
                                                {HelperService.formatCurrency({
                                                    value: orderItem.cost_price_frozen || 0,
                                                    currency: "USD",
                                                    precision: supplierModel.pricing_precision || 2,
                                                })}
                                            </div>
                                            <KitItemsDisplay orderItem={orderItem} />
                                        </div>
                                        <div className={"text-end"}>
                                            {HelperService.formatCurrency({
                                                value: orderItem.total || totalPrice,
                                                currency: "USD",
                                                precision: supplierModel.pricing_precision || 2,
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </InnerContentDiv>

                        <CenterLineDiv></CenterLineDiv>

                        <InnerContentDiv>
                            <OwTitle title={"shipping_address"} tag={"h6"} isBold={true} />
                            <AddressDisplay address={order.Ship_To} showName={true} showCompanyName={true} />
                        </InnerContentDiv>
                    </SectionContainerDiv>

                    <SectionContainerDiv className={"mt-2"}>
                        <InnerContentDiv className={"text-center"}>
                            <OwTitle title={"payment_information"} tag={"h5"} isBold={true} />
                        </InnerContentDiv>

                        <CenterLineDiv />

                        <InnerContentDiv className={"d-flex justify-content-between "}>
                            <div>
                                <OwTitle title={"payment_method"} tag={"h6"} isBold={true} />
                                {!paymentMethodDetail ? null : (
                                    <div className={"d-flex align-items-center"}>
                                        <CardIcon>
                                            <CreditCardBrandIcon brand={paymentMethodDetail.brand} />
                                        </CardIcon>
                                        <div className={"ms-2"}>**** {paymentMethodDetail.last4}</div>
                                    </div>
                                )}
                            </div>

                            <div className={"w-15r text-end"}>
                                <div className={"d-flex justify-content-between"}>
                                    <OwLabel title={"subtotal"} />
                                    {HelperService.formatCurrency({
                                        value: order.sub_total || 0,
                                        currency: "USD",
                                        precision: supplierModel.pricing_precision || 2,
                                    })}
                                </div>

                                <div className={"d-flex justify-content-between"}>
                                    <OwLabel title={"shipping"} />
                                    {HelperService.formatCurrency({
                                        value: order.shipping || 0,
                                        currency: "USD",
                                        precision: supplierModel.pricing_precision || 2,
                                    })}
                                </div>

                                <div>----</div>

                                <div className={"d-flex justify-content-between"}>
                                    <OwLabel title={"tax"} />
                                    {HelperService.formatCurrency({
                                        value: order.tax || 0,
                                        currency: "USD",
                                        precision: supplierModel.pricing_precision || 2,
                                    })}
                                </div>

                                <div>----</div>

                                <div className={"d-flex justify-content-between"}>
                                    <b>
                                        <OwLabel title={"grand_total"} />
                                    </b>

                                    <b>
                                        {HelperService.formatCurrency({
                                            value: order.grand_total || 0,
                                            currency: "USD",
                                            precision: supplierModel.pricing_precision || 2,
                                        })}
                                    </b>
                                </div>
                            </div>
                        </InnerContentDiv>
                    </SectionContainerDiv>
                </div>
            )}
        </div>
    );
};

const SectionContainerDiv = styled.div`
    border: 2px solid var(--main-text-color);
`;

const InnerContentDiv = styled.div`
    padding: 0.5rem;
`;

const CenterLineDiv = styled.div`
    border: 2px solid var(--main-text-color);
    width: 100%;
`;

const CardIcon = styled.div`
    font-size: 1.3rem;
`;
